export function cx(...classes: (string|boolean)[]) {
  return classes.filter(s=>s).join(" ")
}